import { updateCount as v, scheduler as l } from "./ghl-ui.es1652.js";
import { ResizeObservation as u } from "./ghl-ui.es1653.js";
import { ResizeObserverDetail as f } from "./ghl-ui.es1654.js";
import { resizeObservers as s } from "./ghl-ui.es1655.js";
var a = /* @__PURE__ */ new WeakMap(), c = function(o, t) {
  for (var e = 0; e < o.length; e += 1)
    if (o[e].target === t)
      return e;
  return -1;
}, h = function() {
  function o() {
  }
  return o.connect = function(t, e) {
    var r = new f(t, e);
    a.set(t, r);
  }, o.observe = function(t, e, r) {
    var n = a.get(t), i = n.observationTargets.length === 0;
    c(n.observationTargets, e) < 0 && (i && s.push(n), n.observationTargets.push(new u(e, r && r.box)), v(1), l.schedule());
  }, o.unobserve = function(t, e) {
    var r = a.get(t), n = c(r.observationTargets, e), i = r.observationTargets.length === 1;
    n >= 0 && (i && s.splice(s.indexOf(r), 1), r.observationTargets.splice(n, 1), v(-1));
  }, o.disconnect = function(t) {
    var e = this, r = a.get(t);
    r.observationTargets.slice().forEach(function(n) {
      return e.unobserve(t, n.target);
    }), r.activeTargets.splice(0, r.activeTargets.length);
  }, o;
}();
export {
  h as ResizeObserverController
};
